import { checkAlipayWithholdAccountStatus } from '@/api/domain/finance'
import { checkWalletWithhold } from '@/api/withhold'
import { Message } from '@qs/ui'
import { WITHHOLD_TYPE } from './const'

const checkApi = {
  [WITHHOLD_TYPE.WALLET]: checkWalletWithhold,
  [WITHHOLD_TYPE.ALIPAY]: checkAlipayWithholdAccountStatus,
  [WITHHOLD_TYPE.MIXED]: checkWalletWithhold, // 混合支付使用网约钱包的校验逻辑
}

const codeInfo = {
  29030: '/workbench/dashboard/list',
}

// 网约钱包支付&支付宝支付前置校验
export const check = (orderId, type) => {
  return new Promise((resolve) => {
    checkApi[type]({ orderId }).then((res) => {
      if (res.code === 1) {
        resolve()
      }
    }).catch((err) => {
      const { code, msg } = err
      if (!code) throw (err)
      if (Object.keys(codeInfo).includes(String(code))) {
        Message({
          showClose: true,
          message: `<div style="margin-right: -20px"><span>${msg}</span><a style="margin-left: 8px" href="javascript:void(0)" onclick="window.open('${codeInfo[code]}', '_blank')">立即配置</a><div>`,
          dangerouslyUseHTMLString: true,
          duration: 5000,
          type: 'warning',
        })
      }
    })
  })
}
